import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M340.001-340.001h279.998v-279.998H340.001v279.998zm-127.692 200q-30.308 0-51.308-21t-21-51.308v-535.382q0-30.308 21-51.308t51.308-21h535.382q30.308 0 51.308 21t21 51.308v535.382q0 30.308-21 51.308t-51.308 21H212.309z"
      ></path>
    </svg>
  );
}

export default Icon;
